import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { DatabaseProvider } from "@/lib";
import { indexPageConfig } from "@/config"; // ← import our new config
import "./styles.css";

// ─────────────────────────────────────────────────────────────────────────────
// Set <title> and <meta name="description"> at runtime
// ─────────────────────────────────────────────────────────────────────────────
const { title, description } = indexPageConfig;

// 1) Set document.title
document.title = title;

// 2) Find the <meta id="meta-description"> and set its content
const descTag = document.getElementById("meta-description");
if (descTag) {
  descTag.setAttribute("content", description);
}

ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
).render(
  <React.StrictMode>
    <DatabaseProvider>
      <App />
    </DatabaseProvider>
  </React.StrictMode>
);
